<template>
    <div class="method-fields" v-if="selectedMethod">
        <component :is="selectedMethod.fields.component" />
    </div>
</template>

<script>

    import { mapState } from "vuex";

    import FieldsInstructions from "./FieldsInstructions";
    import FieldsNone from "./FieldsNone";
    import FieldsEbanx from "./FieldsEbanx";
    import FieldsDynamic from "./FieldsDynamic";
    import FieldsAdyen from "./FieldsAdyen";

    export default {
        name: "Fields",
        computed: {
            ...mapState({
                selectedMethod: state => state.payment.selectedMethod,
            })
        },
        components: {
            FieldsInstructions,
            FieldsNone,
            FieldsEbanx,
            FieldsDynamic,
            FieldsAdyen,
        }
    }

</script>
